var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncreaseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.101,
    height: 16.208,
    viewBox: "0 0 11.101 16.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#45c471",
    d: "M5.079 10.868l-.109-.092L.345 6.341q-.036-.034-.07-.072l-.011-.012a1.1 1.1 0 0 1-.138-.2l-.011-.024L.1 6.01v-.005l-.007-.017V5.98l-.009-.015V5.944l-.015-.015A1.066 1.066 0 0 1 0 5.65V5.6v-.024-.024-.024a1.071 1.071 0 0 1 .015-.155v-.11l.005-.019.006-.02A1.081 1.081 0 0 1 .2 4.927l.013-.018.008-.009.007-.009a1.131 1.131 0 0 1 .106-.121L4.97.324a1.194 1.194 0 0 1 1.637 0A1.077 1.077 0 0 1 6.7 1.79l-.1.1-2.646 2.55h11.1a1.109 1.109 0 0 1 .135 2.213l-.135.008H3.953l2.654 2.544a1.077 1.077 0 0 1 .1 1.466l-.1.1a1.195 1.195 0 0 1-1.527.092z",
    transform: "translate(11.101) rotate(90)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon);
export default __webpack_public_path__ + "static/media/Increase-Icon.a3056ca0052961179681ed2022720ec8.svg";
export { ForwardRef as ReactComponent };